import React from 'react';
import { Users } from 'lucide-react';

// Chrome extension API types
declare global {
  interface Window {
    chrome: {
      runtime: {
        sendMessage: (message: any) => Promise<any>;
      };
    };
  }
}

const RoleSelection = () => {
  const handleRoleSelect = async () => {
    try {
      // Send message to background script to set role
      const response = await window.chrome.runtime.sendMessage({
        action: 'setRole',
        role: 'teacher'
      });
      
      if (response.success) {
        // Open teacher dashboard
        window.chrome.runtime.sendMessage({ action: 'openTeacherDashboard' });
        // Close this popup
        window.close();
      }
    } catch (error) {
      console.error('Failed to set role:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl p-8 max-w-md w-full">
        <div className="text-center mb-8">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center">
            <img src="/icon.png" alt="Traffic Lite" className="h-16 w-16 object-contain" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Traffic Lite</h1>
          <p className="text-gray-600">Choose your role to get started</p>
        </div>
        
        <div className="space-y-4">
          <button
            onClick={handleRoleSelect}
            className="w-full flex items-center justify-center space-x-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
          >
            <Users className="w-6 h-6" />
            <span className="text-lg">I'm a Teacher</span>
          </button>
        </div>
        
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            You can change your role later in the settings
          </p>
        </div>
      </div>
    </div>
  );
};

export default RoleSelection; 